import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Button from '../components/Button';
import { Home, Search } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <MainLayout title="Seite nicht gefunden | SENKAY">
      <div className="section-container min-h-[60vh] flex items-center justify-center">
        <div className="text-center max-w-2xl mx-auto">
          <div className="mb-8">
            <div className="text-9xl font-bold text-primary-gray-border">404</div>
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-primary-text-dark mb-4">
            Seite nicht gefunden
          </h1>

          <p className="text-lg text-primary-text-muted mb-8">
            Die gesuchte Seite existiert nicht oder wurde verschoben.
            Verwenden Sie die Navigation oder kehren Sie zur Startseite zurück.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button variant="primary" size="lg" icon={Home}>
                Zur Startseite
              </Button>
            </Link>
            <Link to="/leistungen">
              <Button variant="secondary" size="lg" icon={Search}>
                Leistungen durchsuchen
              </Button>
            </Link>
          </div>

          {/* Popular Links */}
          <div className="mt-12 pt-8 border-t border-primary-gray-border">
            <h3 className="text-sm font-semibold text-primary-text-dark mb-4">
              Beliebte Seiten
            </h3>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/leistungen" className="text-primary-blue-mid hover:underline">
                Unsere Leistungen
              </Link>
              <Link to="/ueber-uns" className="text-primary-blue-mid hover:underline">
                Über uns
              </Link>
              <Link to="/kontakt" className="text-primary-blue-mid hover:underline">
                Kontakt
              </Link>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default NotFoundPage;
